module.exports = __webpack_public_path__ + "img/timers-off.8ce18b46.jpg";